"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPatientNumber = exports.concatIfDef = exports.getUserName = exports.dateToString = void 0;
function dateToString(content) {
    if (typeof content === 'string') {
        content = new Date(content);
    }
    return `${content.getFullYear()}-${('0' + (content.getMonth() + 1)).slice(-2)}-${content.getDate()}`;
}
exports.dateToString = dateToString;
const DEFAULT_NAME = 'PATIENT NAME NOT FOUND';
function getUserName(user) {
    const results = `${concatIfDef(user === null || user === void 0 ? void 0 : user.fname, ' ')}${user === null || user === void 0 ? void 0 : user.lname}`;
    return results || DEFAULT_NAME;
}
exports.getUserName = getUserName;
function concatIfDef(value, toConcat) {
    return value != undefined ? value.toString().concat(toConcat) : '';
}
exports.concatIfDef = concatIfDef;
const DEFAULT_PATIENT_NUMBER = 'PATIENT NUMBER NOT FOUND';
function getPatientNumber(patient) {
    const patientNumber = (patient === null || patient === void 0 ? void 0 : patient.patientNumber) || DEFAULT_PATIENT_NUMBER;
    return {
        text: patientNumber,
        style: 'patientNumber',
    };
}
exports.getPatientNumber = getPatientNumber;
//# sourceMappingURL=utils.js.map